export const sizeButton = 32
export const heightContainer = 104

export const iconProps = { width: sizeButton, height: sizeButton }
